module.exports = __webpack_public_path__ + "img/aAudit.1bc07a0f.png";